var _rect, _path, _g, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 185,
    viewBox: "0 0 221 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 75,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1486_31000)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 44.3048C105.039 42.8015 110.247 42.7643 115.14 44.1978L201.676 69.5467C207.399 71.2232 207.437 79.3173 201.729 81.0469L115.378 107.214C110.337 108.742 104.95 108.702 99.9323 107.101L18.214 81.0202C12.618 79.2343 12.6564 71.3026 18.2695 69.5709L100.166 44.3048Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1486_31000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 75.5627C146 76.5466 129.044 75.5627 117.694 75.5627C106.344 75.5627 89 74.7652 89 73.7814C89 72.7975 98.201 72 109.551 72C120.901 72 146 74.5789 146 75.5627Z",
    fill: "#7294FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.506 35C142.506 54.33 126.836 70 107.506 70C88.1762 70 72.5062 54.33 72.5062 35C72.5062 15.67 88.1762 0 107.506 0C126.836 0 142.506 15.67 142.506 35Z",
    fill: "#4671F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 35C123 43.2843 116.284 50 108 50C99.7157 50 93 43.2843 93 35C93 26.7157 99.7157 20 108 20C116.284 20 123 26.7157 123 35Z",
    fill: "url(#paint1_linear_1486_31000)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114 35C114 38.3137 111.314 41 108 41C104.686 41 102 38.3137 102 35C102 31.6863 104.686 29 108 29C111.314 29 114 31.6863 114 35Z",
    fill: "#F3F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1486_31000",
    x: 75,
    y: 58,
    width: 85,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1486_31000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_31000",
    x1: 206,
    y1: 130,
    x2: 14,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_31000",
    x1: 93.3704,
    y1: 50,
    x2: 123.37,
    y2: 21.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.8f34c65b0eaf158283ec8f67b50c09c3.svg";
export { ForwardRef as ReactComponent };